import dayjs from "dayjs";
import _ from "underscore";

import { ImportantMessageInterface } from "@/interfaces/important-message.interface";

/**
 * イベント用ユーティリティ
 */
export class MessageUtil {
  /**
   * 年を取得する
   */
  public static getYear(str: string): string {
    // 日付のみの文字列は一律"Asia/Tokyo"として扱う
    return dayjs.tz(str, "Asia/Tokyo").format("YYYY");
  }

  // /**
  //  * イベントを並べ替える　※重要なお知らせはbackend側でsort済のためこの処理は不要(2022/7/7)
  //  */
  // public static sort(
  //   messages: ImportantMessageInterface[]
  // ): ImportantMessageInterface[] {
  //   messages = _.sortBy(
  //     messages,
  //     (message: ImportantMessageInterface) =>
  //       MessageUtil.getTime(message.displayDate)
  //   );
  //   messages.reverse();

  //   return messages;
  // }

  /**
   * 日付けを取得する
   */
  private static getTime(str: string): string {
    return dayjs(str).format("YYYYMMDDHHmmss");
  }
}
